<template>
  <main class="fix">
    <!-- breadcrumb-area -->
    <section class="breadcrumb__area breadcrumb__bg">
      <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100"
        :style="{ backgroundImage: `url('assets/img/banner/banner1.png')` }"></div>
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="breadcrumb__content">
              <h2 class="title">Detile Berita</h2>
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item"><a href="javascript:void(0);" @click="$router.push('/')">Beranda</a></li>
                  <li class="breadcrumb-item active" aria-current="page">Detile Berita</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="breadcrumb__shape">
        <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
        <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
        <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
        <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
        <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
      </div>
    </section>
    <!-- breadcrumb-area-end -->
    <!-- blog-details-area -->
    <section class="blog_area mt-5">
      <div class="container">
        <div class="blog__inner-wrap">
          <div class="row">
            <div class="col-70">
              <div class="blog__details-wrap">
                <div class="blog__details-thumb">
                  <img :src="file_path + form.foto" alt="Apexa" />
                </div>
                <div class="blog__details-content">
                  <h2 class="title">{{ form.judul }}</h2>
                  <div class="blog-post-meta">
                    <ul class="list-wrap">
                      <li><a href="javascript:void(0)" class="blog__post-tag-two">{{ form.kategori_id }}</a></li>
                      <li>
                        <div class="blog-avatar">
                          <div class="avatar-content">
                            <p>By <a href="javascript:void(0)">{{ form.createBy }}</a></p>
                          </div>
                        </div>
                      </li>
                      <li><i class="fas fa-calendar-alt"></i>{{ UMUM.tglConvert(form.createAt) }}</li>
                    </ul>
                  </div>
                  <p v-html="form.isi"></p>
                  <div class="blog__details-bottom">
                    <div class="row align-items-center">
                      <div class="col-md-7">
                        <!-- <div class="post-tags">
                          <h5 class="title">Tags:</h5>
                          <ul class="list-wrap">
                            <li><a href="#">Finance</a></li>
                            <li><a href="#">Data</a></li>
                            <li><a href="#">Agency</a></li>
                          </ul>
                        </div> -->
                      </div>
                      <div class="col-md-5">
                        <div class="post-share">
                          <h5 class="title">Bagikan:</h5>
                          <ul class="list-wrap">
                            <li><a :href="facebookLink" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                            <li><a :href="twitterLink" target="_blank"><i class="fab fa-twitter"></i></a></li>
                            <li><a :href="whatsappLink" target="_blank"><i class="fab fa-whatsapp"></i></a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-30">
              <aside class="blog__sidebar">
                <div class="sidebar__widget">
                  <h4 class="sidebar__widget-title">Berita Terbaru</h4>
                  <div class="sidebar__post-list">
                    <div class="sidebar__post-item" v-for="data in list_data" :key="data.id">
                      <div class="sidebar__post-thumb">
                        <a href="javascript:void(0)" @click="push_berita(data.id)"><img :src="file_path + data.foto"
                            alt="Apexa" /></a>
                      </div>
                      <div class="sidebar__post-content">
                        <h5 class="title"><a href="javascript:void(0)" @click="push_berita(data.id)">{{ data.judul
                            }}</a></h5>
                        <span class="date"><i class="flaticon-time"></i>{{ UMUM.tglConvert(data.createAt) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- blog-details-area-end -->
  </main>
</template>

<script>

import UMUM from '../../library/umum'

export default {

  data: function () {
    return {
      id: this.$route.query.id,
      data_load: false,
      form: {
        id: '',
        judul: '',
        sumber: '',
        deskripsi: '',
        isi: '',
        foto: '',
        unit_kerja: '',
        status: '',
        keterangan: '',
        createBy: '',
        createAt: '',
        kategori_id: '',
      },
      unit_kerja: this.$store.state.UNIT_KERJA,
      UMUM: UMUM,
      id: '',
      cek_load_data: true,
      cek_load_data_list: true,
      file_old: "",
      file_path: this.$store.state.url.URL_APP + "uploads/",

      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
    }
  },


  // =============================================================== METHODS =========================================================================
  methods: {

    getView: function () {
      this.cek_load_data = true;
      fetch(this.$store.state.url.URL_BERITA + "isi_berita", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          id: this.$route.query.id,
        })
      })
        .then(res => res.json())
        .then(res_data => {
          var berita = res_data[0];
          this.form.createAt = berita.createAt;
          this.form.createBy = berita.createBy;
          this.form.deskripsi = berita.deskripsi;
          this.form.isi = berita.isi;
          this.form.judul = berita.judul;
          this.form.sumber = berita.sumber;
          this.form.foto = berita.foto;
          this.form.kategori_id = berita.kategori_id;
          this.cek_load_data = false;

          // console.log("===========================");
          // console.log(berita);
          // console.log(res_data);
          // console.log("===========================");

          // this.myData = berita.judul;
          this.getAsyncData();
        });
    },
    getList: function () {
      fetch(this.$store.state.url.URL_BERITA + "viewOPD", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          unit_kerja: this.unit_kerja
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          // console.log(res_data);
        });
    },
    getAsyncData: function () {
      var self = this;
      var deskripsi = this.form.judul;
      window.setTimeout(function () {
        self.myData = deskripsi
        self.$emit('updateHead')
      }, 3000)
    },

    push_berita: function (id) {
      this.$router.push('/isiBerita?id=' + id);
      this.getView();
    },

    to_facebook: function () {
      window.open("http://www.facebook.com/sharer.php?u=" + this.HOST, '_blank');
    },
    to_twitter: function () {
      // alert(this.HOST)
      window.open("https://twitter.com/share?url=" + this.HOST + "&amp;text=" + this.judul, '_blank');
    },

    // ================== PAGINASI ====================
    alertku: function (type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function () {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.getList();
    },

    // ================== PAGINASI ====================
  },
  // =============================================================== METHODS =========================================================================

  computed: {
    shareUrl() {
      return encodeURIComponent(window.location.href)
    },
    encodedJudul() {
      return encodeURIComponent(this.form.judul)
    },
    facebookLink() {
      return `https://www.facebook.com/sharer.php?u=${this.shareUrl}&quote=${this.encodedJudul}`;
    },
    twitterLink() {
      return `https://twitter.com/intent/tweet?text=${this.encodedJudul}&url=${this.shareUrl}`;
    },
    whatsappLink() {
      return `https://wa.me/?text=${this.encodedJudul}%20${this.shareUrl}`;
    }
  },

  mounted() {
    this.getView();
    this.getList();
    // this.getAsyncData();
    // alert(this.$route)
    // console.log('id = '+this.$route.query.id)
    // console.log(this.HOST);
  },
  // metaInfo: function(){
  //   return {
  //     title: this.form.judul,
  //   meta: [
  //     // { name: "description", content: "Learn coding with our free tutorials" },
  //     // { name: "keywords", content: "react,vue,angular" },
  //     {
  //       property: 'fb:app_id',
  //       content: '1879416282388598',
  //       vmid: 'fb:app_id'
  //     },
  //     {
  //       property: 'og:url',
  //       content: 'http://konaweselatankab.go.id/#/lihatberita?id=i33wt9e4k13bmpod',
  //       vmid: 'og:url'
  //     },
  //     {
  //       property: 'og:type',
  //       content: 'article',
  //       vmid: 'og:type'
  //     },
  //     // {
  //     //   property: 'og:title',
  //     //   content: 'BERITA KABUPATEN KONAWE SELATAN',
  //     //   template: chunk => `${chunk} - My page`,
  //     //   vmid: 'og:title'
  //     // },
  //     {
  //       property: 'og:description',
  //       content: this.form.judul,
  //       vmid: 'og:description'
  //     },
  //     {
  //       property: 'og:image',
  //       content: 'https://i.stack.imgur.com/GKgIC.png',
  //       vmid: 'og:image'
  //     }

  //     //you can also add open graph tags heren
  //   ]
  //   }
  // },

  // head: {
  //   title: {
  //     inner: 'Apakah ini???'
  //   },
  //   // Meta tags
  //   meta: function(){
  //     return [
  //     { p: 'fb:app_id', c: '1879416282388598' },
  //     { p: 'og:url', c: 'http://konaweselatankab.go.id/#/lihatberita?id=i33wt9e4k13bmpod' },
  //     { p: 'og:type', c: 'article' },
  //     { p: 'og:title', c: 'Konawe Selatanku' },
  //     { p: 'og:description', c: this.myData },
  //     { p: 'og:image', c: 'https://i.stack.imgur.com/GKgIC.png' },

  //     ]
  //   }

  // }







};



</script>


<style>
.img_berita img {
  width: 100% !important;
  height: auto !important;
}
</style>
